// if ( typeof ModalBox !== 'function' ) {
	class ModalBox extends HTMLElement {

		constructor() {
            console.log("Modal Box")

			window.inertElems = document.querySelectorAll('[data-js-inert]');

			super();
			this.o = {
				...{
					show: 10, 
					frequency: 'day', 
					enabled: true,
					showOnce: true,
					closeByKey: true,
					disableScroll: true,
					blockTabNavigation: false,
				}, ...JSON.parse(this.dataset.options)
			};
			
			if ( this.o.enabled ) {
			
				this._modalKey = `modal-${document.location.hostname}-${this.id}`;
				this._modalStorage = ! localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
				if ( this.querySelector('[data-content]') ) {
					this._modalText = this.querySelector('[data-content]').textContent;
				}

				const timeNow = new Date().getTime();
				const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

				let showModal = false;

				if ( this._modalStorage == 'empty'
					|| ( this.o.frequency == 'day' && inBetween > 86400 )
					|| ( this.o.frequency == 'week' && inBetween > 604800 )
					|| ( this.o.frequency == 'month' && inBetween > 2419200 )
					|| this._modalStorage['content'] != this._modalText
				) {
					showModal = true
				}

				if ( showModal ) {
					setTimeout(()=>{
						this.show();
					}, parseInt(this.o.show*1000));
					setTimeout(()=>{
						this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
					}, 100);
				}

			} else {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}

			if ( this.o.closeByKey ) {
				document.addEventListener('keydown', e=>{
					if ( e.keyCode == 27 ) {
						if ( this.classList.contains('active') ) {
							this.hide(this.o.showOnce);
						}
					}
				});
			}

		}

		show(){
			this.setAttribute('style', '');
			setTimeout(()=>{
				this.classList.add('active');
				if ( this.o.disableScroll ) {
					document.body.classList.add('modal-opened');
				}
				if ( this.o.blockTabNavigation ) {
					window.inertElems.forEach(elm=>{
						elm.setAttribute('inert', '');
					});
				}
			}, 10);
			setTimeout(()=>{
				if ( this.querySelector('[data-js-first-focus]') ) {
					this.querySelector('[data-js-first-focus]').focus();
				}
			}, 250);
		}
		hide(remember=false){
			this.classList.remove('active');
			document.body.classList.remove('modal-opened');
			setTimeout(()=>{
				this.style.display = 'none';
			}, 500);
			if ( remember && ! Shopify.designMode ){
				localStorage.setItem(this._modalKey, JSON.stringify({
					'shown': (new Date().getTime()),
					'content': this._modalText
				}));
			}
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});
		}

	}

// }

  // if ( typeof customElements.get('modal-box') == 'undefined' ) {
		customElements.define('modal-box', ModalBox);
	// }



  class QuickView extends HTMLElement {
  constructor() {
     console.log("quick view modal 1")
    super();
  }

  connectedCallback() {
    this.quickViewModal = document.querySelector(".modal--quickview");
    this.buttons = this.querySelectorAll(".quickview-btn");

    if (!this.quickViewModal) {
      console.error("QuickView modal element not found.");
      return;
    }

    this.buttons.forEach((button) =>
      button.addEventListener("click", this.openQuickView.bind(this))
    );
  }

  openQuickView(event) {
    console.log("quick view modal")
    const qvContainer = event.target.closest(".quickview_container");
    if (!qvContainer) {
      console.error("QuickView container not found.");
      return;
    }

    const qvButton = qvContainer.querySelector(".quickview-btn");
    const qvHandle = qvButton?.dataset?.productHandle;

    if (!qvHandle) {
      console.error("Product handle not found on button.");
      return;
    }

    const qvURL = `${window.shopUrl}/products/${qvHandle}?view=custom-qv`;
    console.log("qvURL - ", qvURL)
    this.fetchQuickViewContent(qvURL);
  }

  async fetchQuickViewContent(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const responseText = await response.text();
      console.log("responseText - ", responseText);
      const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
      console.log("responseHTML - ", responseHTML);
      const source = responseHTML.querySelector('section[id^="QuickViewProduct-"]');

      if (source) {
        const qvContent = this.quickViewModal.querySelector(".modal-content");
        this.setInnerHTML(qvContent, source.innerHTML);
        this.loadProductScripts();
        this.openModal();
      } else {
        console.error("QuickView content not found in fetched response.");
      }
    } catch (error) {
      console.error("Error fetching QuickView content:", error);
    }
  }

  openModal() {
    this.quickViewModal?.show();
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinject and execute scripts
    element.querySelectorAll("script").forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  loadProductScripts() {
    if (!window.productPageScripts) {
      const scripts = this.quickViewModal.querySelectorAll('script[src]');
      scripts.forEach((scriptTag) => {
        const script = document.createElement("script");
        script.src = scriptTag.src;
        document.body.appendChild(script);
      });
      window.productPageScripts = true;
    }
  }
}

customElements.define("quick-view", QuickView);